<h1>{{note}}</h1>

<table>
  <thead>
    <tr>
      <th></th>
      <th><h2>Guitar</h2></th>
      <th><h2>Ukulele</h2></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let level of [1]">
      <td>Level {{level}}</td>
      <td><app-chord-render *ngIf="note" [size]="100" [chord]="note" [level]="level" instrument="guitar" [graph]="true"></app-chord-render></td>
      <!-- <td><app-chord-render *ngIf="note" [size]="100" [chord]="note" [level]="level" instrument="ukulele" [graph]="true"></app-chord-render></td> -->
    </tr>

    <tr>
      <td colspan="2"><h3>Debug</h3></td>
    </tr>
    <tr>
      <td><pre>{{guitar.debug}}</pre></td>
      <td><pre>{{ukulele.debug}}</pre></td>
    </tr>
  </tbody>
</table>


